/**
 * 移除对象中的 null 和 undefine值
 *
 * @param object
 * @returns
 */

export interface Dictionary<T> {
    [index: string]: T;
}

export const removeNully = <T>(obj: Dictionary<T> | null | undefined) => {
    if (!obj) {
        return;
    }

    const dic: Dictionary<T> = Object.create(null);

    Object.keys(obj).forEach(key => {
        if (obj[key] !== null && obj[key] !== undefined) {
            dic[key] = obj[key];
        }
    });

    return dic;
};

export interface IfObject {
    [propName: string]: any;
}

/**
 * 判断是否为对象
 *
 * @param {*} val 待校验的值
 * @return {boolean}
 */
export const isObject = (val: object) => {
    return Object.prototype.toString.call(val) === '[object Object]';
};

/**
 * 获取url中的query，生成键值对
 *
 * @param {string} url 样本url
 * @return {Object} query键值对
 */
export const getQueryObject = (url: string): IfObject => {
    if (!url) {
        return {};
    }
    const search = url.substring(url.lastIndexOf('?') + 1);
    const obj: IfObject = {};
    const reg = /([^?&=#]+)=([^?&#]*)/g;
    search.replace(reg, (rs, $1, $2) => {
        const name = $1;
        const val = $2;
        obj[name] = val || '';
        return rs;
    });
    return obj;
};


// eslint-disable-next-line no-var
export var getQueryStr = (obj: IfObject): string => {
    if (isObject(obj)) {
        return Object.getOwnPropertyNames(obj)
            .map(key => {return `${key}=${obj[key]}`;})
            .join('&');
    }
    return '';
};

export const readAgent = () => {
    const [browserVerson] = window.navigator.userAgent.split(' ');

    const [browser, version] = browserVerson.split('/');

    return [browser, version] as const;
};

export const copyToClipboard = (textToCopy: string): boolean => {
    const copyDom = document.createElement('div');

    copyDom.innerText = textToCopy;
    copyDom.style.position = 'absolute';
    copyDom.style.top = '0';
    copyDom.style.right = '0';
    document.body.appendChild(copyDom);

    // 创建选中范围
    const range = document.createRange();
    range.selectNode(copyDom);

    // 移除剪切板中内容
    window?.getSelection()?.removeAllRanges();
    // 添加新的内容到剪切板
    window?.getSelection()?.addRange(range);

    // 复制
    const hasSuccess = document.execCommand('copy');

    copyDom.remove();
    return hasSuccess;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export const throttle = (fn: Function, delay = 100) => {
    let isHandle: boolean = false;

    return (...args: any[]) => {
        if (isHandle) {
            return;
        }

        isHandle = true;

        window.setTimeout(() => {
            fn(...args);
            isHandle = false;
        }, delay);
    };
};

/**
 * 页面图片加载完成
 */
export const loadedAllImages = () => {
    return new Promise((reslove, reject) => {
        setTimeout(() => {
            const imagesDOM = document.querySelectorAll('img');
            const imageLoadPromises = Array.from(imagesDOM)?.map(imageDOM => new Promise((resolve, reject) => {
                imageDOM.addEventListener('load', () => {
                    resolve('done');
                });
                imageDOM.addEventListener('error', reject);
                imageDOM.addEventListener('abort', reject);
            }));
            const result = Promise.allSettled(imageLoadPromises);
            result.then(reslove).catch(reject);
        }, 17);
    });
};

export const isDoctorApp = () => {
    const ua = window.navigator.userAgent;
    return ua.includes('bddoctorbox');
};

export const isWechart = () => {
    const ua = window.navigator.userAgent?.toLowerCase();
    return ua.includes('micromessenger');
};

export const isMobile = () => {
    const ua = window.navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
};

export const isDeskWeixin = () => {
    return isWechart() && !isMobile();
};

export const isWiseAgent = (userAgentInfo: string) => {
    // eslint-disable-next-line max-len
    const isWise = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.exec(userAgentInfo);
    return !!isWise;
};

/**
 *
 * @desc   对象序列化
 * @param  {Object} obj
 * @return {String}
 */
export function stringfyQueryString(obj: Record<string, any>): string {
    if (!obj) {
        return '';
    }
    const pairs = [];

    // eslint-disable-next-line guard-for-in
    for (const key in obj) {
        const value = obj[key];

        if (value instanceof Array) {
            for (let i = 0; i < value.length; ++i) {
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                pairs.push(encodeURIComponent(key + '[' + i + ']') + '=' + encodeURIComponent(value[i]));
            }
            continue;
        }
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
    }
    return pairs.join('&');
}
// 判断是否是正常url
export const judgeUrl = (url: string) => {
    if (!url) {
        return;
    }
    const newUrl = url.trim() || '';
    const urlReg = /^http(s)?:\/\/(.*?)\//;
    const swanUrlReg = /baiduboxapp:\/\/(.*?)\//;
    if (urlReg.test(newUrl) || swanUrlReg.test(newUrl)) {
        return true;
    }
    return false;
};

// 解析弹窗url的moduleId，弹窗url格式 dialog://moduleId
export const analysisDialogId = (url: string) => {
    const urlParamsArray = url && url.split('//');
    if (urlParamsArray && urlParamsArray.length >= 1) {
        const moduleId = parseInt(urlParamsArray[1], 10);
        return !isNaN(moduleId) && moduleId;
    }
    return 0;
};

/**
 * url拼接参数
 *
 * @param {string} url url
 * @param {object} params 需要拼接到url的参数是一个对象
 */
export function addParamsToUrl(url: string, params: Record<string, any>) {
    if (!url) {
        return '';
    }


    let newUrl = url;
    let originalParams = {};
    let urlParams = '';

    // 将原始链接中的参数保存到 originalParams 对象中
    if (url.includes('?')) {
        urlParams = url.split('?')[1];
        originalParams = urlParams.split('&').reduce((obj, item) => {
            const [key, value] = item.split('=');
            obj[key] = value;
            return obj;
        }, {});
    }

    // 遍历要添加的参数，如果原始链接中不存在同名参数，则添加新参数
    Object.keys(params).forEach(key => {
        const value = params[key];
        if (
            !originalParams.hasOwnProperty(key)
            && value !== undefined
            && value !== ''
        ) {
            urlParams += `&${key}=${params[key]}`;
        }
    });

    if (urlParams) {
        // 将新的参数添加到原始链接后面
        if (url.includes('?')) {
            newUrl = `${url.split('?')[0]}?${urlParams}`;
        } else {
            newUrl += `?${urlParams.substring(1)}`;
        }
    }

    return newUrl;
}

/**
 * 获取url中的参数值
 *
 * @param {string} url url
 * @param {string} paramName 需要拼接到url的参数是一个对象
 */
export function getUrlParamValue(url: string, paramName: string) {
    if (!(url && paramName)) {
        return '';
    }
    const targetUrlObj = new URL(window.location.href);
    return targetUrlObj.searchParams.get(paramName) ?? '';
}

/**
 * 获取H5当前的协议+域名
 */
export function getPageBaseUrl() {
    return window.location.origin || `${window.location.protocol}//${window.location.hostname}`;
}

/**
 * 是否百度端内
 */
export function isBaiduBoxApp() {
    const userAgent = navigator.userAgent;
    const isBd = userAgent.includes('baiduboxapp')
        // 普通大字版
        || userAgent.includes('tomas')
        // 关怀版
        || userAgent.includes('bdapp')
        // 鸿蒙百度
        || userAgent.includes('baiduarkwebapp')
        // 关怀版
        || userAgent.includes('baiduboxsenior');
    return isBd;
}
